<template>
  <router-view :style="[getPrimaryColor]" />
  <transition-group name="showMenu">
    <QuickView v-if="$store.getters.modalIsQuickView" :id="$store.state.app.currentActiveModal"/>
    <!-- <Modal v-if="$store.state.app.currentActiveModal === 'newsletter'"/> -->
  </transition-group>
</template>

<script>
import colors from "./views/color_schemes.json";
import QuickView from "./components/molecules/Modal/QuickView.vue"
// import Modal from "./components/molecules/Modal/NewsLetterPopup.vue"
import {products} from "./data/auctions.json"
import { guestLoginService } from './services/authService';
import { NO_USER, GUEST_LOGGED_IN_USER } from './constents/app';

export default {
  components: {QuickView},
  created() {
    document.addEventListener('keydown', e => {
        let key = e.key;
        if (key && 'Escape' === key) {
            this.$store.commit('forceCloseModal')
        }
    }, false);

    this.guestUserLogin();
  },
  watch: {
    "$store.state.app.currentActiveModal": function() {
      let body = document.getElementsByTagName("BODY")[0];
      let modalsState = this.$store.state.app.currentActiveModal;
      if (modalsState !== "") {
        body.style.overflow = "hidden";
      } else {
        body.style.overflow = "auto";
      }
    },
  },
  data() {
    return {
      colors,
    };
  },
  computed: {
    getCurrentColor() {
      return process.env.VUE_APP_PRIMARY_COLOR === ""
        ? colors[process.env.VUE_APP_CURRENT_THEME]
        : process.env.VUE_APP_PRIMARY_COLOR;
    },
    getPrimaryColor() {
      return (
        "--primary-color:" +
        this.getCurrentColor +
        ";" +
        "--swiper-theme-color: " +
        this.getCurrentColor +
        ";"
      );
    },
    getCurrentQuickViewProduct() {
      return products.find((prod) => {
          return prod.id == this.$store.state.app.currentActiveModal.split('-')[1]
      })
    }
  },
  methods:{
    async guestUserLogin() {
      if(this.$store.getters["user/LoggedInUserType"] === NO_USER) {
        let res = await guestLoginService();
        if (!res || !res.token) return;
        localStorage.setItem('guestToken', res.token);
        if (res.refreshtoken) {
          localStorage.setItem('refreshtoken', res.refreshtoken);
        }
        this.$store.dispatch("user/updateLoggedInUserType", GUEST_LOGGED_IN_USER);
      }
    }
  }
};
</script>
<style src="./assets/main.css"></style>
